export default __webpack_public_path__ + "static/media/croptop-large-right.58a95d8c.jpg";